import React from 'react'
import { useTranslation } from 'react-i18next'
import { getSections, type Tag } from './constants'

type PopularConditionsProps = {
  layout: 'mobile' | 'pc'
}

const toggleTag = (tag: Tag) => {
  const params = new URLSearchParams(window.location.search)
  const values = (params.get(tag.key)?.split(',') || []).filter((value) => value.length > 0)
  const next = values.includes(tag.value) ? values.filter((value) => value !== tag.value) : [...values, tag.value]
  if (next.length > 0) {
    params.set(tag.key, next.join(','))
  } else {
    params.delete(tag.key)
  }
  if (params.get('page')) params.set('page', '1')
  window.location.href = params.toString() ? `?${params.toString()}` : '/'
}

export const PopularConditions: React.FC<PopularConditionsProps> = ({ layout }) => {
  const { t } = useTranslation()
  const sections = React.useMemo(() => getSections(t), [t])
  const popular = sections.find((section) => section.id === 'popular')
  if (!popular) return null

  const isPc = layout === 'pc'

  return (
    <div
      className={isPc ? 'flex flex-wrap items-baseline gap-x-3 gap-y-1' : 'w-full'}
      style={isPc ? undefined : { maxWidth: 420, margin: '0 auto' }}
    >
      <div className="font-noto font-size-12 mb-3">{isPc ? `${popular.label})` : `${popular.label}）`}</div>
      <div className={isPc ? 'contents' : 'flex flex-wrap gap-3'}>
        {popular.tags.map((tag) => (
          <button
            key={`${tag.key}:${tag.value}`}
            type="button"
            className="font-noto border-b-2 border-green hover:opacity-70 font-size-14"
            onClick={() => toggleTag(tag)}
          >
            +{tag.label}
          </button>
        ))}
      </div>
    </div>
  )
}
